import { Helmet } from 'react-helmet-async';
import BusinessOverview from 'src/sections/overview/dashboards/views/businessOverview';

export default function SearchPerformanceOverview() {
  return (
    <>
      <Helmet>
        <title>Search Performance</title>
      </Helmet>

      <BusinessOverview />
    </>
  );
}
